import ConceptLockerSummaryPopup from './ConceptLockerSummaryPopup';
import './ConceptLockerSummaryPopup.scss'

export default ConceptLockerSummaryPopup;